import BgNsContent from '@britishgasenergy/react-nucleus/dist/nuc-components/NsContent';
import { ReactNode } from 'react';

type NsContentProps = {
  children?: ReactNode;
  spacing?: 'compact' | 'cosy' | 'normal' | 'loose';
  slot?: string;
  role?: string;
};

export const NsContent = ({
  spacing = 'normal',
  children,
  ...rest
}: NsContentProps) => {
  return (
    <BgNsContent {...rest} spacing={spacing}>
      {children}
    </BgNsContent>
  );
};

export default NsContent;
